import { type AxiosError } from 'axios'
import {
  type QueryObserverOptions,
  type QueryFunctionContext,
  useQuery
} from 'react-query'

import { fetchQueryData } from 'hooks/use-gremlin-query'
import { rolesQueryKeys } from 'queries/roles/query-keys'

import type { RbacBody } from 'types/api/rbac/rbac'

async function fetchGetRoles({
  queryKey: [endpoint]
}: QueryFunctionContext<ReturnType<typeof rolesQueryKeys.getRoles>>) {
  return await fetchQueryData<RbacBody>(endpoint)
}

export function useGetRoles(
  options?: Omit<
    QueryObserverOptions<RbacBody, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<RbacBody, AxiosError>({
    ...options,
    queryKey: rolesQueryKeys.getRoles(),
    queryFn: fetchGetRoles
  })
}
